import {GlobalUtility} from '../../service/global-utility.service';
import {
  PURPOSES,
  VESSELS,
  GET_CREW_KEY_DETAILS,
  RESERVATION_BATCH,
  RESERVATION_BATCH_NO,
  GET_CREW_ENDORSE_LIST,
  GET_BATCH_KEY_DETAILS,
  GET_RESERVATION_REMARKS,
  APPROVE_CREW_ENDORSE,
  CANCEL_CREW_ENDORSE,
  CREW_RESERVATION, COUNT_ROOMS_AVAILABLE, MAILING_RESROUCE,
} from '../../service/constants.service';
import axios from 'axios';
import {AlertsService} from '../../service/alerts.service';

const state = {
  vessels: [],
  crewEndorse: {},
  crewEndorseList: [],
  newCrewEndorse: {
    // batchId:'',
    crew: {},
    purposes: [],
    file: {},
    // pcr_issued_date: '',
    pcr_swab_date: '',
    pcr_result_date: '',
    remarks: '',
    // isPriority : '',
    // isApproved : '',
    // status : '',
  },

  purposes: [],

  crewKeyDetails: [],

  batchControlNum: '',

  newBatch: {
    num_crew: null,
    batch_no: null,
    intended_vessel: null,
    dateCheckIn: null,
    dateCheckOut: null,
    crewEndorseList: [],  //use this object sending set of endorselist to save.
  },

  batchKeyDetails:[],

  tnkcRoomsCount : '',
  zenRoomsCount: '',
};

const mutations = {
  set_vessels: (state, params) => {
    state.vessels = params;
  },

  set_crew_endorsed : (state,param) =>{
    state.crewEndorse = param;
  },

  set_edit_crew_endorse: (state, param) => {
    let crewEndorse = state.newBatch.crewEndorseList.find(
        (endorse, index) => index === param);
    state.crewEndorse = crewEndorse;
  },

  set_crew_endorse_list: (state, params) => {
    state.crewEndorseList = params;
  },

  set_new_endorsement: (state, params) => {
    state.newCrewEndorse = params;
  },

  set_purposes: (state, params) => {
    state.purposes = params;
  },

  set_crew_keyDetails: (state, params) => {
    state.crewKeyDetails = params;
  },

  set_add_crew_endorsement: (state, params) => {
    state.newBatch.crewEndorseList.push(params);
  },

  set_batch_no: (state, param) => {
    state.batchControlNum = param;
  },

  set_new_endorsement_null: (state) => {
    state.newCrewEndorse = {
      // batchId:'',
      crew: {},
      purposes: [],
      file: {},
      // pcr_issued_date: '',
      pcr_swab_date: '',
      pcr_result_date: '',
      remarks: '',
      // isPriority : '',
      // isApproved : '',
      // status : '',
    };
  },

  set_new_batch_null: (state) => {
    state.newBatch = {
      num_crew: null,
      batch_no: null,
      intended_vessel: null,
      dateCheckIn: null,
      dateCheckOut: null,
      crewEndorseList: [],  //use this
    };
  },

  set_delete_crewEndorseMent: (state, param) => {
    let index = state.newBatch.crewEndorseList.findIndex((endorseList, index) => index === param);
    state.newBatch.crewEndorseList.splice(index, 1);
  },

  set_update_crewEndorseMent: (state, params) => {
    let endorsement = state.newBatch.crewEndorseList.find(
        (endorsement, index) => endorsement.crew.id == params.crew.id);
    Object.assign(endorsement, params);
  },

  set_batch_key : (state,params)=>{
    state.batchKeyDetails = params;
  },

  set_null_crewendorsed : (state,params) =>{
    state.crewEndorse = {};
  },

  set_update_crew_endorse_dtls : (state,params) =>{},

  set_count_available_rooms : (state,params) =>{
    state.tnkcRoomsCount = params[0].tnkc;
    state.zenRoomsCount = params[1].zr;
  },

  set_delete_crewEndorseMent_list : (state,params)=>{
    let index = state.crewEndorseList.findIndex((endorseList, index) => endorseList.crew_reservation_id === params.id);
    state.crewEndorseList.splice(index, 1);
  },

};

const actions = {
  async getVessels({commit}) {
    return await axios.get(VESSELS).then((response) => {
      let vesselList = response.data.vessels;
      commit('set_vessels', vesselList);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Vessels');
      return false;
    });
  },

  getCrewEndorsedList({commit}, params) {
    return null;
  },

  getCrewEndorseDetails({commit}, params) {
    return  axios.get(`${CREW_RESERVATION}/${params.id}`).then((response)=>{
      const crewEndorsed = {
        crew_reservation_id : response.data.crew_reservation_id,
        batch : response.data.batch,
        vessel : response.data.batch.vessel,
        crew : response.data.crew,
        crew_id : response.data.crew_id,
        endorsed_check_in : response.data.endorsed_check_in,
        endorsed_check_out : response.data.endorsed_check_out,
        purposes : response.data.purposes,
        endorsedBy : response.data.endorsedBy,
        endorsedAt : response.data.endorsedAt,
        isBooked : response.data.is_booked,
        pcrFile : response.data.pcrFile,
        is_active : response.data.is_active,
      };
      commit('set_crew_endorsed',crewEndorsed);
      commit('set_remarks',response.data.remarks);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get crew endorse details.');
      return false;
    })
  },

  updateCrewEndorseDetails({commit},params){
    console.log(params);
    return axios.put(`${CREW_RESERVATION}/${params.crew_reservation_id}`,params).then((response)=>{
      commit('set_update_crew_endorse_dtls');
      const remarks = {
        subject : response.data.remarks.original.subject,
        remarks : response.data.remarks.original.remarks,
        created_at : response.data.remarks.original.created_at,
        remark_by : response.data.remarks.original.remark_by,
      }
      commit('set_new_remarks',remarks);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Update EndorseDetails');
      return false;
    });
  },

  //todo
  deleteCrewEndorseDetails(){},

  addCrewEndorseMent({commit}, params) {
    //check if endorse is exist
    let crewEndorse = state.newBatch.crewEndorseList.some(crewEndorse => {
      return crewEndorse.crew.id === params.crew.id;
    });

    if (!crewEndorse) {
      commit('set_add_crew_endorsement', params);
      return true;
    } else {
      return false;
    }
  },

  createNewEndorsementBatch({commit}, params) {
    return axios({
      method: 'post',
      url: `${RESERVATION_BATCH}`,
      data: params,
    }).then((response) => {
      console.log(response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Saving set of crew endorse.');
      return false;
    });
  },

  editViewEndorseMent({commit}, param) {
    commit('set_edit_crew_endorse', param);
  },

  updateCrewEndorseMent({commit}, params) {
    let endorsement = state.newBatch.crewEndorseList.find((endorsement, index) => endorsement.crew.id == params.crew.id);
    commit('set_update_crewEndorseMent', params);
    return true;
  },

  deleteCrewEndorseMent({commit}, params) {
    commit('set_delete_crewEndorseMent', params);
  },

  deleteCrewEndorseMentList({commit}, params) {
    return axios.delete(`${CREW_RESERVATION}/${params}`).then((response)=>{
      commit('set_delete_crewEndorseMent_list',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Delete EndorseList');
      return false;
    })
  },

  getPurposeList({commit}) {
    return  axios.get(PURPOSES).then((response) => {
      commit('set_purposes', response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Getting Purpose List');
      return false;
    });
  },

  async getCrewKeyDetails({commit}) {
    return await axios.get(GET_CREW_KEY_DETAILS).then((response) => {
      commit('set_crew_keyDetails', response.data);
      swal.close();
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Crew Key Details');
      return false;
    });
  },

  async getBatchControllNo({commit}) {
    return await axios.get(RESERVATION_BATCH_NO).then((response) => {
      commit('set_batch_no', response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Batch Controll No.');
      return false;
    });
  },

  setNewEndorsementNull({commit}) {
    commit('set_new_endorsement_null');
  },

  // setNewBatchNull({commit}) {
  //   commit('set_new_batch_null');
  // },

  async getCrewEndorseList({commit}, params) {
    let url = `${GET_CREW_ENDORSE_LIST}?page=${params.page}`;
    return await axios.post(url, params).then((response) => {
      commit('set_crew_endorse_list', response.data.data);
      commit('set_endorse_pagination', response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Crew Endorse List');
      return false;
    });
  },

  getBatchKeyDetails({commit}){
    return axios.get(GET_BATCH_KEY_DETAILS).then((response)=>{
      commit('set_batch_key',response.data);
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Batch Key Details');
      return false;
    });
  },

  async getCrewEndorseRemarks({commit},params){
    return await axios.post(GET_RESERVATION_REMARKS,params).then((response)=>{
      const crewEndorse = {
        crew : response.data.crew,
        id : response.data.crew_reservation_id,
      };
      commit('set_remarks',response.data.remarks);
      commit('set_crew_endorsed',crewEndorse);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Reservation Remarks');
      return false;
    });
  },

  setNullCrewEndorsed({commit}){
    commit('set_null_crewendorsed');
  },

  setNewBatchNull({commit}){
    commit('set_new_batch_null');
  },

  approvedCrewEndorse({commit},params){
    return axios.post(APPROVE_CREW_ENDORSE,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Approve Crew Endorse');
      return false;
    });
  },

  cancelCrewEndorse({commit},params){
    return axios.post(CANCEL_CREW_ENDORSE,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Cancel Crew Endorse');
      return false;
    });
  },

  getCountRoomsAvailable({commit},params){
    return  axios.post(COUNT_ROOMS_AVAILABLE,params).then((response)=>{
      console.log(response.data);
      commit('set_count_available_rooms',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Count Rooms Available');
      return false;
    });
  },
};

const getters = {
  crewEndorse: state => state.crewEndorse,
  crewEndorseList: state => state.crewEndorseList,
  vessels: state => state.vessels,
  newCrewEndorse: state => state.newCrewEndorse,
  purposes: state => state.purposes,
  crewKeyDetails: state => state.crewKeyDetails,
  newBatch: state => state.newBatch,
  batchControlNum: state => state.batchControlNum,
  batchKeyDetails: state => state.batchKeyDetails,
  tnkcRoomsCount : state => state.tnkcRoomsCount,
  zenRoomsCount : state => state.zenRoomsCount,
};

export default {state, actions, mutations, getters};

